import {uid} from "./utils";

const PREFIX = "31415926";
const nodeValueRegExp = new RegExp("^" + PREFIX + "_");

let htmlRequested = false;
const table = {};

function getNode(id) {
  if(table.hasOwnProperty(id) && document.documentElement.contains(table[id])) return table[id];
  delete table[id];
  if(!htmlRequested) return null;
  refreshTable();
  return table[id] || null;
}

function getHTML(id) {
  htmlRequested = true;
  return `<!--${id}-->`;
}

function refreshTable() {
  const nodeIterator = document.createNodeIterator(document.body, NodeFilter.SHOW_COMMENT, null, false);
  let node;
  while((node = nodeIterator.nextNode())) {
    if(nodeValueRegExp.test(node.nodeValue)) table[node.nodeValue] = node;
  }
  htmlRequested = false;
}

export default class Sentinel {
  constructor() {
    this.id = uid(PREFIX);
  }
  getHTML() { return getHTML(this.id); }
  getReference() { return getNode(this.id); }
};
